import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-installation-program',
  templateUrl: './installation-program.component.html',
  styleUrls: ['./installation-program.component.scss']
})
export class InstallationProgramComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
